// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2M9Il","header":"ReportDetails_header__Gnycg","title":"ReportDetails_title__1a4Pc","left":"ReportDetails_left__1kpAH"};